// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import * as React from 'react';
import HeadStyle from '../../../head-style/head-style';
import { IRostelecomStyleParamsStoreState } from '../styling/rostelecom-styles-store';
import { IReactRadiumFreeStyles } from '../../../base/radium-types';

interface IProps {
    key?: string;
    styles: IRostelecomStyleParamsStoreState;
}

let globalId = 1;

class LoaderComponent extends React.Component<IProps, any> {
    private readonly _id: number;

    // tslint:disable-next-line:typedef (autogenerated)
    constructor(props, options) {
        super(props, options);
        this._id = globalId++;
        if (globalId > 100000) {
            globalId = 1;
        }
    }

    private getStyle(): IReactRadiumFreeStyles {
        return {
            svgStyle: {
                animation: `rtk-loader-animation-${this._id} 1.5s linear 0s infinite`
            }
        };
    }

    private getHtmlStyle(): string {
        return `
            @keyframes rtk-loader-animation-${this._id} {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `;
    }

    public render(): JSX.Element {
        const style = this.getStyle();
        const gradientId = 'rtk-loader-gradient-' + this._id;
        return (
            <svg style={style.svgStyle} height="100%" width="100%" viewBox="0 0 24 24">
                <HeadStyle styleText={this.getHtmlStyle()} />
                <defs>
                    <linearGradient id={gradientId}>
                        <stop offset="5%" stopColor={this.props.styles.baseMediumDarkColor} />
                        <stop offset="85%" stopColor={'transparent'} />
                    </linearGradient>
                </defs>
                <path
                    key="p1"
                    fill={'url(#' + gradientId + ')'}
                    stroke="none"
                    d="M 12,12 m-10,0 a10,10 0 1,0 20,0 l-2,0 a 8,8 0 1,1 -16,0"
                />
                <path
                    key="p2"
                    fill={this.props.styles.baseMediumDarkColor}
                    stroke="none"
                    d="M 12,12 m-10,0 a10,10 0 1,1 20,0 a 1,1 0 0,1 -2,0 a 8,8 0 1,0 -16,0"
                />
            </svg>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default LoaderComponent;
